import { AxiosInstance } from 'axios';
import { LicenceRef } from './refs';
import {
    AllocateManualLicenceInput,
    AssignLicenceUserInput,
    LicenceFilterInput,
    SyncLicenceInput,
    UpdateLicencePlanInput,
} from './inputs';
import { LicenceResource } from './resources';
import { CollectionResource } from '@app/data/resources';
import qs from 'qs';

export default class Licence {
    private basePath = '/api/licence';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // TODO: This is incorrect name. Name must be related to *subscription* sync, like `syncBySubscriptionId`
    sync = async (input: SyncLicenceInput): Promise<LicenceRef> => {
        const { data } = await this.http.post(`${this.basePath}/sync/subscription`, input);

        return data;
    };

    // Get licence list
    get = async (filter: LicenceFilterInput): Promise<CollectionResource<LicenceResource, {}>> => {
        const query = qs.stringify({ ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Create new licence with 'manual' origin
    allocateManual = async (input: AllocateManualLicenceInput): Promise<LicenceRef> => {
        const { data } = await this.http.post(`${this.basePath}/manual`, input);

        return data;
    };

    // Get single licence by id
    getById = async (id: ID): Promise<LicenceResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Update licence plan
    updatePlan = async (id: ID, input: UpdateLicencePlanInput): Promise<LicenceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/plan`, input);

        return data;
    };

    // Shutdown licence
    shutdown = async (id: ID): Promise<LicenceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/shutdown`);

        return data;
    };

    // Assign user to licence
    assignUser = async (id: ID, input: AssignLicenceUserInput): Promise<LicenceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/user`, input);

        return data;
    };

    // Remove user from licence
    removeUser = async (id: ID): Promise<LicenceRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/user`);

        return data;
    };
}
